// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Field__Component a[data-v-d0b98d66] {\r\n    text-align: center;\r\n    display: block;\n}\r\n", ""]);
// Exports
module.exports = exports;
